/* ============================================================================
   nuud US — social proof clips
   ----------------------------------------------------------------------------
   Four autoplaying videos is tens of megabytes on arrival. Instead each clip
   loads its source and starts only once it is actually on screen, and pauses
   when it leaves. Visitors who ask for reduced motion get the poster frame and
   no video at all.
   ========================================================================= */
(function () {
  'use strict';

  var reduced = window.matchMedia &&
                window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function boot() {
    var vids = document.querySelectorAll('[data-lazy-video]');
    if (!vids.length || reduced) return;

    if (!('IntersectionObserver' in window)) {
      // No observer: leave the posters in place rather than loading everything.
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          if (!v.src) {
            v.src = v.getAttribute('data-src');
          }
          var play = v.play();
          if (play && play.catch) play.catch(function () { /* autoplay refused */ });
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { rootMargin: '100px 0px', threshold: 0.25 });

    Array.prototype.forEach.call(vids, function (v) { io.observe(v); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
